import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
export default {
  mixins: [services],
  data() {
    return {
      DialogVisible: false,
      loading: false,
      title: '',
      formData: [],
      ConsigneeInfo: {},
      currentNum: 1,
      Express: []
    }
  },
  methods: {

    show(opts) {
      this.DialogVisible = true
      this.Express = []
      this.title = opts.title
      this.GetStockByOrderId(opts.OrderId)

    },
    // 切换订单号
    changeCode(currentNum) {
      console.log(currentNum)
      let id = this.formData[currentNum - 1].LogisticsId
      let code = this.formData[currentNum - 1].LogisticsCode
      if (id > 0) {
        this.GetExpress(id, code)
      }

    },
    dialogClose() {
      // 查看关闭
      this.DialogVisible = false
    },

  },

}


// WEBPACK FOOTER //
// ./src/pages/Family/OrderList/stockDialog/vm.js